const All = () => {
  return (
    <section
      className="p-4 wow animate__animated  animate__fadeIn"
      style={{
        visibility: "visible",
        animationName: "fadeIn",
      }}
    >
      <div className="container-fuild">
        <div className="row g-3">
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              style={{
                visibility: "visible",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/nnVpN4S/portfolio-item171.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">naked soap</h5>
                  <p className="card-text">WEB AND PHOTOGRAPHY</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.2s"
              style={{
                visibility: "visible",
                animationDelay: "0.2s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/6841WHk/portfolio-item172.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">berlin design</h5>
                  <p className="card-text">Branding and brochure</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.4s"
              style={{
                visibility: "visible",
                animationDelay: "0.4s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/z6c1xKs/portfolio-item174.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">abdtract comics</h5>
                  <p className="card-text">branding and identity</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.6s"
              style={{
                visibility: "visible",
                animationDelay: "0.6s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/0cfw8qL/portfolio-item175.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">trabag collection</h5>
                  <p className="card-text">web and photography</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.8s"
              style={{
                visibility: "visible",
                animationDelay: "0.8s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/ZfJPFkM/portfolio-item176.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">harddo stone</h5>
                  <p className="card-text">branding and identity</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.10s"
              style={{
                visibility: "visible",
                animationDelay: "0.10s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/cN0wSwd/portfolio-item177.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">Educamp school</h5>
                  <p className="card-text">branding and identity</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.12s"
              style={{
                visibility: "visible",
                animationDelay: "0.12s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/0KwRQnL/portfolio-item183.jpg"
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back ">
                  <h5 className="card-title">third eye glasses</h5>
                  <p className="card-text">branding and identity</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className=" wow animate__animated  animate__fadeUp"
              data-wow-delay="0.14s"
              style={{
                visibility: "visible",
                animationDelay: "0.14s",
                animationName: "fadeUp",
              }}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-inner">
                  <div className="portfolio-card-front">
                    <img
                      src="https://i.ibb.co/FV74Pvj/portfolio-item186.jpg"
                      className="card-img-top img-fuild"
                      alt="..."
                    />
                  </div>
                </div>
                <div className="portfolio-card-back">
                  <h5 className="card-title">violaor series</h5>
                  <p className="card-text">web and photography</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default All;
